var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6C14 8.20914 12.2091 10 10 10C7.79086 10 6 8.20914 6 6C6 3.79086 7.79086 2 10 2C12.2091 2 14 3.79086 14 6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4062 15.5135V13.8919C14.4062 12.847 15.2877 12 16.375 12H18.625C19.7123 12 20.5938 12.847 20.5938 13.8919V15.5135H20.875C21.4963 15.5135 22 15.9975 22 16.5946V20.9189C22 21.516 21.4963 22 20.875 22H14.125C13.5037 22 13 21.516 13 20.9189V16.5946C13 15.9975 13.5037 15.5135 14.125 15.5135H14.4062ZM16.0938 13.8919V15.5135H18.9062V13.8919C18.9062 13.7426 18.7803 13.6216 18.625 13.6216H16.375C16.2197 13.6216 16.0938 13.7426 16.0938 13.8919Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 20.9189C11.5 21.2421 11.5587 21.5471 11.6648 21.8265C11.1278 21.9402 10.5709 22 10 22C5.58172 22 2 18.4183 2 14C2 12.8954 2.89543 12 4 12H13.4934C13.1246 12.5342 12.9062 13.1814 12.9062 13.8919V14.31C12.0858 14.7332 11.5 15.5732 11.5 16.5946V20.9189Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLock);
export default __webpack_public_path__ + "static/media/user-lock.55c314610822404c6a8227b838584914.svg";
export { ForwardRef as ReactComponent };